import React, { useEffect } from "react"; // Added useEffect
import UserFeeds from "./userFeeds/UserFeeds";
import Recruiter from "./recruiterFeeds/RecruiterFeeds"
import { useSelector, useDispatch } from "react-redux"; // Added useDispatch
import { setLoading } from "../../slice/authSlice"; // Added setLoading

const UserHome = () => {
  const user = useSelector(state => state.auth.userInfo);
  const dispatch = useDispatch();

  useEffect(() => {
    // When the dashboard loads, we ensure any leftover 
    // loader from the login/redirect process is turned off.
    // dispatch(setLoading(false));

    // Cleanup: ensure loader is off if the user navigates away
    return () => dispatch(setLoading(false));
  }, [dispatch]);
  
  return (
    <div className="user_home_container">
      {user?.role === "user" ? <UserFeeds /> : <Recruiter/>}
    </div>
  );
};

export default UserHome;